import { gql } from '@apollo/client';

const GET_OHTS_LIST = gql`
  query GetOfficeOfHealthTechnologies {
    officeOfHealthTechnologies {
      Id
      Value
      DisplayName
    }
  }
`;

export default GET_OHTS_LIST;
